import React, {useState} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {BASE_URL} from './helper'



export default function Register() {

    const navigate = useNavigate()

    const [userdata, setuserdata] = useState({fname:"", email:"", password:""})

    const handleSubmit = async(e)=>{
        e.preventDefault();
        const response = await fetch(`${BASE_URL}/api/createuser`,{
            method: "POST",
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({name:userdata.fname, email:userdata.email, password:userdata.password})
        });
        const json = await response.json()
        console.log(json);
        if (!json.success) {
            alert("Enter vailed data")
        }
        if (json.success) {
            alert("Register Successfully")
            navigate("/login")
        }
    }

    const changevalue = (event) => {
        setuserdata({...userdata,[event.target.name]:event.target.value})

    }


    return (
        <div>
            <div className='container'>
                <form onSubmit={handleSubmit}>
                <div className="m-3">
                        <label htmlFor="exampleInputEmail1">Full Name</label>
                        <input type="text" className="form-control" placeholder="Enter name" name='fname' onChange={changevalue} value={userdata.fname} />
                    </div>
                    <div className="m-3">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input type="email" className="form-control" placeholder="Enter email" onChange={changevalue} name='email' value={userdata.email} />
                    </div>
                    <div className="m-3">
                        <label htmlFor="exampleInputPassword1">Password</label>
                        <input type="password" className="form-control" placeholder="Password" onChange={changevalue} name='password' value={userdata.password} />
                    </div>
                    <button type="submit" className=" m-3 btn btn-primary">Register</button>
                    <Link className="m-3 btn btn-success" to="/Login">Login</Link>
                </form>
            </div>
        </div>
    )
}
